import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ACLService} from "@delon/acl";
import {MenuService} from "@root/layout/nav/menu.service";
import {zip} from "rxjs";
import {catchError, finalize} from 'rxjs/operators';
import {AppService} from "@root/app.service";

@Injectable({
  providedIn: 'root'
})
export class StartupService {

  constructor(
    private http: HttpClient,
    private acl: ACLService,
    private menuSrv: MenuService,
    private appSrv: AppService
  ) {
    console.log('[hostex] App Start Up ...')
  }

  private viaHttp(resolve, reject) {
    const headers = new HttpHeaders({
      'auth': 'no'
    });
    zip(
      this.http.get('/api/config/init', { headers }),
      this.http.get('/api/member/detail', { headers })
    )
      .pipe(
        catchError(e => {
          console.warn(`StartupService.load: Network request failed`, e);
          return [];
        }),
        finalize(() => {
          resolve(null)
        })
      )
      .subscribe(
        ([cRst, mRst]) => {
          console.log('Startup.load Complete: ', [cRst, mRst]);

          const config = cRst && cRst.data;
          const member = mRst && mRst.data;

          if (!config || !member) {
            resolve(null);
            return;
          }

          let roles = [];
          let abilities = [];

          const { group_company_role, is_subaccount, is_global, permission_blacklist = [], operator_name, user_account } = config;
          switch (group_company_role) {
            case 'master':
              roles = ['company_master'];
              // this.acl.setRole(['company_master']);
              break;
            case 'member':
              roles = ['company_slave', 'master'];
              // this.acl.setRole(['company_slave', 'master']);
              break;
            case 'none':
              roles = is_subaccount ? ['slave'] : ['master'];
              // is_subaccount ? this.acl.setRole(['slave']) : this.acl.setRole(['master']);
              break;
            default:
              roles = ['master'];
          }
          abilities = permission_blacklist.map(b => `${b.title}.${b.permission}`);
          // 后端给的是能力黑名单，所以判断时要取反
          this.acl.set({ role: roles, ability: abilities });
          console.log('[Startup SRV] ACL: ', this.acl.data);

          this.appSrv.setMember({ status: member.status, edition: member.current.edition });
          this.appSrv.setApp({ international: is_global });
          this.appSrv.setUser({ account: user_account, name: operator_name });
          console.log('[Startup SRV] Member: ', this.appSrv.member);
          console.log('[Startup SRV] User: ', this.appSrv.user);
          console.log('[Startup SRV] App: ', this.appSrv.app);
          resolve(null);
        },
        error => {
          console.warn('Startup.load error: ', error)
          resolve(null);
        }
      )
  }

  load(): Promise<any> {
    return new Promise((resolve, reject) => {
      /** 所有的初始化操作在这里完成 */
      this.viaHttp(resolve, reject);
      // resolve({})
    })
  }


}
